import i18n from 'services/i18n'
import config from 'services/config'
const certificateBaseImageList = require('@/assets/js/certificateBaseList')
const linestartForBottomItems = 12
const marginBetweenLabelAndValue = 1

function setCertificateListLabel (certificate, isLearningPathSingleList = false) {
    certificate.setFontSize(17)
    certificate.setFont('Quicksand-Bold')
    isLearningPathSingleList ? certificate.text(9, 28, i18n.t('Certificates.certificate_title'))
        : certificate.text(9, 28, i18n.t('CertificateList.certificatelist_title'))
    return certificate
}

function setUserNameHasCompletedCourses (certificate, filteredCourseList) {
    certificate.setFont('Nunito-Bold')
    certificate.setFontSize(17)
    const firstCertificateInArrays = Object.values(filteredCourseList).find(arr => arr.length > 0)?.[0]
    let fullName = firstCertificateInArrays.certificate.userName || ''
    certificate.text(10, 40, fullName)
    certificate.setFont('Nunito-Regular')
    certificate.setFontSize(16)
    certificate.text(10, 46.5, i18n.t('CertificateList.has_completed_courses'))
    return certificate
}

function setColumnLabels (certificate) {
    certificate.setFont('Quicksand-Bold')
    certificate.setFontSize(10)
    certificate.setTextColor('white')

    switch (config.appLanguage) {
    case 'se':
        certificate.text(13, 55.5, i18n.t('CertificateList.column_course'))
        certificate.text(123, 55.5, i18n.t('CertificateList.column_authorization'))
        certificate.text(154, 55.5, i18n.t('CertificateList.column_akt_timmar'))
        certificate.text(184, 55.5, i18n.t('CertificateList.column_date'))
        break
    case 'no':
        certificate.text(13, 55.5, i18n.t('CertificateList.column_course'))
        certificate.text(115, 55.5, i18n.t('CertificateList.column_authorization'))
        certificate.text(182, 55.5, i18n.t('CertificateList.column_date'))
        break
    case 'fi':
        certificate.text(13, 55.5, i18n.t('CertificateList.column_course'))
        certificate.text(139, 55.5, i18n.t('CertificateList.column_authorization'))
        certificate.text(180, 55.5, i18n.t('CertificateList.column_date'))
        break
    }
    certificate.setTextColor('black')
    certificate.setFont('Nunito-Bold')
    return certificate
}

function setTotalWatchedAmountLabel (certificate, totalWatched, unitForHour, isLearningPath = false) {
    certificate.setTextColor('white')
    certificate.setFontSize(14)
    if (isLearningPath) {
        certificate.text(11, 236, i18n.t('CertificateList.learningpaths_watched_total'))
        certificate.text(getLineCoordinateForAttribute(certificate, i18n.t('CertificateList.learningpaths_watched_total')), 236, convertMinutesToHours(totalWatched, unitForHour))
    } else {
        certificate.text(11, 236, i18n.t('CertificateList.courses_watched_total'))
        certificate.text(getLineCoordinateForAttribute(certificate, i18n.t('CertificateList.courses_watched_total')), 236, convertMinutesToHours(totalWatched, unitForHour))
    }
    return certificate
}

function addPageNumber (certificate, pageNumber) {
    certificate.setTextColor('black')
    certificate.setFont('Nunito-Bold')
    certificate.setFontSize(13)
    certificate.text(185, 8, i18n.t('CertificateList.page') + ' ' + pageNumber.toString())
    return certificate
}

function convertMinutesToHours (time, unitForHour) {
    const hours = Math.floor(time / 60)
    const minutes = time % 60
    return hours + unitForHour + ' ' + minutes + 'min'
}

function convertMinutesToHoursRawNumber (time) {
    const hours = (time / 60).toFixed(2)
    return +hours
}

function setupNewPdfPage (certificate) {
    certificate.setFont('Nunito-Regular')
    let height = 290
    let width = 210
    certificate.addImage(certificateBaseImageList.certificateString, 'JPEG', 0, 7, width, height)
    return certificate
}

function getLineCoordinateForAttribute (certificate, label) {
    return (certificate.getTextWidth(label) + linestartForBottomItems + marginBetweenLabelAndValue)
}

function getLineCoordinateForAuthorizations (certificate, label) {
    return (certificate.getTextWidth(label) + 115)
}

function setAuthorizationsForIndividualCourse (certificate, course, rowCoordinate) {
    let authorizationCoordinate = rowCoordinate
    if (course.durations !== undefined) {
        switch (config.appLanguage) {
        case 'se':
        case 'no':
            course.durations.forEach((authorization) => {
                let authorizationCreditsLabel = authorization.category + ': ' + authorization.credits
                certificate.text(115, authorizationCoordinate, authorizationCreditsLabel)
                certificate.setFont('Nunito-Regular')
                certificate.text(getLineCoordinateForAuthorizations(certificate, authorizationCreditsLabel), authorizationCoordinate, ' t')
                authorizationCoordinate += 4
            })
            break
        case 'fi':
            course.durations.forEach((authorization) => {
                let authorizationCreditsLabel = authorization.category + ': ' + (authorization.credits).toFixed(2)
                certificate.text(139, authorizationCoordinate, authorizationCreditsLabel)
                certificate.setFont('Nunito-Regular')
                authorizationCoordinate += 4
            })
            break
        }
    }
    return certificate
}

function addLearningPathCourseListParagraph (certificate, learningPathName) {
    certificate.setFontSize(14)
    certificate.setFont('Nunito-Bold')
    certificate.setTextColor('black')
    let splitLearningPathName = certificate.splitTextToSize(learningPathName, 160)
    certificate.text(9, 38, splitLearningPathName)
    certificate.setFont('Nunito-Regular')
    let textCoordinate = 43
    if (splitLearningPathName.length > 1) {
        textCoordinate = 43 + (splitLearningPathName.length - 1 * 5)
    }
    certificate.text(9, textCoordinate, i18n.t('CertificateList.learning_includes_following_courses'))
    return certificate
}

function addCourseTypeSubHeader (icon, certificate, rowCoordinate, title) {
    certificate.setTextColor('#e47700')
    certificate.setFont('icomoon')
    certificate.setFontSize(12)
    certificate.text(12, rowCoordinate, icon)
    certificate.setTextColor('black')
    certificate.setFont('Quicksand-Bold')
    certificate.text(19, rowCoordinate, title)
    return certificate
}

function getSummaryForAllAuthorizationDurations (listableCourses, learningPaths) {
    let summary = {}
    let processedCertificateIds = new Set()

    const sumAuthorizations = (courseCertificates) => {
        courseCertificates.forEach((courseCertificate) => {
            if (!processedCertificateIds.has(courseCertificate.id) && courseCertificate.durations !== undefined && courseCertificate.durations !== null && courseCertificate.durations.length > 0) {
                processedCertificateIds.add(courseCertificate.id)
                courseCertificate.durations.forEach((authorization) => {
                    if (!summary[authorization.category]) {
                        summary[authorization.category] = 0
                    }
                    if (config.appLanguage === 'fi') {
                        summary[authorization.category] += (+authorization.credits / 6)
                    } else {
                        summary[authorization.category] += +authorization.credits
                    }
                })
            }
        })
    }
    sumAuthorizations(listableCourses.map(course => course.certificate))
    learningPaths.forEach((learningPath) => {
        sumAuthorizations(learningPath.certificate.courseCertificates)
    })
    return summary
}

export default {
    setCertificateListLabel,
    setUserNameHasCompletedCourses,
    setColumnLabels,
    setTotalWatchedAmountLabel,
    addPageNumber,
    setupNewPdfPage,
    convertMinutesToHours,
    convertMinutesToHoursRawNumber,
    setAuthorizationsForIndividualCourse,
    addCourseTypeSubHeader,
    addLearningPathCourseListParagraph,
    getSummaryForAllAuthorizationDurations,
    getLineCoordinateForAttribute
}
